'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var offset = function offset(_ref) {
  var nestingLevel = _ref.nestingLevel,
      addImageOffset = _ref.addImageOffset,
      addIconOffset = _ref.addIconOffset,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.menu.item;
  var iconPath = path.iconLeft;
  var imgPath = path.image;
  var levelOffset = path.levelOffset;
  var offset = [addIconOffset && [(0, _reactackleCore.getValueString)(iconPath.width || iconPath.height), (0, _reactackleCore.getValueString)(iconPath.marginLeft), (0, _reactackleCore.getValueString)(iconPath.marginRight)].join(' + '), addImageOffset && [(0, _reactackleCore.getValueString)(imgPath.width), (0, _reactackleCore.getValueString)(imgPath.marginLeft), (0, _reactackleCore.getValueString)(imgPath.marginRight)].join(' + '), nestingLevel && (typeof levelOffset === 'string' ? levelOffset + ' * ' + nestingLevel : levelOffset * nestingLevel + 'px')];
  return addIconOffset || addImageOffset || nestingLevel ? 'padding-left: calc(' + offset.filter(Boolean).join(' + ') + ');' : null;
};

var ContentStyled = exports.ContentStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ContentStyled'
})(['flex-grow:1;', ''], offset);

ContentStyled.displayName = 'ContentStyled';